// System constants
export const COMMUNITY_USER_ID = '035554a0-515e-4e0a-9f91-31e060737515'
export const COMMUNITY_USER_EMAIL = 'community@purposecollective.world'
export const COMMUNITY_USER_USERNAME = 'purposecollective'
// Avatar URL will be fetched from database - should be stored in Supabase storage like other avatars